<template>
  <div class="min-h-screen p-3 sm:p-4 md:p-6 lg:p-8 bg-background">
    <!-- Header Section (Full Width Kept) -->
    <div
      class="border-b border-border/50 bg-background/95 backdrop-blur -mx-3 sm:-mx-4 md:-mx-6 lg:-mx-8 px-3 sm:px-4 md:px-6 lg:px-8"
    >
      <div class="max-w-[1600px] mx-auto py-3 sm:py-4">
        <h1 class="text-xl sm:text-2xl md:text-3xl font-bold text-foreground">
          Smart Cards & Device Manager
        </h1>
        <p class="text-xs sm:text-sm text-muted-foreground mt-1">
          Manage your devices and smart cards
        </p>
      </div>
    </div>

    <!-- Main Container -->
    <div class="max-w-[1600px] mx-auto py-6 md:py-8">
      <!-- Moderately Sized Centered Pill Tabs -->
      <div class="flex justify-center mb-8 md:mb-10">
        <div
          class="w-full max-w-2xl grid grid-cols-2 p-1.5 bg-slate-100/90 rounded-2xl border border-slate-200/80 shadow-inner gap-2"
        >
          <button
            v-for="tab in tabs"
            :key="tab.id"
            @click="activeTab = tab.id"
            type="button"
            :class="[
              'flex items-center justify-center gap-3 py-3 px-4 sm:px-6 rounded-xl text-sm sm:text-base font-semibold transition-all duration-200 select-none cursor-pointer',
              activeTab === tab.id
                ? 'bg-white text-blue-600 shadow-sm shadow-slate-200 ring-1 ring-slate-900/5'
                : 'text-slate-500 hover:text-slate-800 hover:bg-white/50',
            ]"
          >
            <component
              :is="tab.icon"
              :class="[
                'w-4 h-4 sm:w-5 sm:h-5 transition-colors flex-shrink-0',
                activeTab === tab.id ? 'text-blue-600' : 'text-slate-400',
              ]"
            />
            <span class="truncate">{{ tab.label }}</span>
            <span
              v-if="activeTab === tab.id"
              class="w-2 h-2 rounded-full bg-blue-600 animate-pulse flex-shrink-0"
            ></span>
          </button>
        </div>
      </div>

      <!-- Tab Content (Full Width) -->
      <div class="relative">
        <transition
          name="fade-slide"
          mode="out-in"
        >
          <div :key="activeTab">
            <div v-if="activeTab === 'smartcards'">
              <SmartCardStatistics />
            </div>

            <div v-else-if="activeTab === 'devices'">
              <DeviceController />
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { ref } from "vue";
  import { Smartphone, CreditCard } from "lucide-vue-next";
  import DeviceController from "@/components/SmartCardAndDevice/Reader.vue";
  import SmartCardStatistics from "@/components/SmartCardAndDevice/Cards.vue";

  const activeTab = ref("smartcards");

  const tabs = [
    {
      id: "smartcards",
      label: "Smart Cards",
      description: "Analyze and order new Smart cards.",
      icon: CreditCard,
    },
    {
      id: "devices",
      label: "Manage Devices",
      description:
        "Control, monitor, and order new Smart devices in real-time.",
      icon: Smartphone,
    },
  ];
</script>

<style scoped>
  .fade-slide-enter-active,
  .fade-slide-leave-active {
    transition: all 0.3s ease-in-out;
  }
  .fade-slide-enter-from {
    opacity: 0;
    transform: translateY(10px);
  }
  .fade-slide-leave-to {
    opacity: 0;
    transform: translateY(-10px);
  }
</style>
